import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "row", "button"]

  toggle(event) {
    event.preventDefault()

    const removing = this.fieldTarget.value !== "1"
    this.fieldTarget.value = removing ? "1" : "0"
    this.rowTarget.classList.toggle("opacity-35", removing)
    this.rowTarget.classList.toggle("line-through", removing)
    this.buttonTarget.textContent = removing ? "Undo" : "×"
    this.buttonTarget.setAttribute("aria-label", removing ? "Undo remove" : "Remove")
  }
}
